module.exports = __webpack_public_path__ + "static/img/logo_19@2x.462bf0ea.png";